/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  ADD_BREADCRUMB,
  SELECT_BREADCRUMB,
  SET_BREADCRUMBS,
  SET_HOME_BREADCRUMB,
  POP_LAST_BREADCRUMB,
} from './actionTypes'
import Resource from './Resource'

const home = [
  {
    //Home
    name: Resource.get('breadcrumb', 'Home'),
    link: '/overview',
  },
]

const breadcrumbs = (state = home, action) => {
  switch (action.type) {
    case ADD_BREADCRUMB:
      return state.concat(action.item)
    case SELECT_BREADCRUMB:
      let index = state.findIndex(crumb => {
        return crumb === action.item
      })
      // clip minumum value at 0
      index = Math.max(index, 0)
      return state.slice(0, index + 1)
    case SET_BREADCRUMBS:
      if(Array.isArray(action.items)) {
        action.items = action.items.filter((item) => { return item.link !== '/settings'});
      }
      let crumbs = action.items
      if (!action.items) {
        crumbs = home
      }
      return crumbs
    case POP_LAST_BREADCRUMB:
      if (state.length === 1) {
        return state
      } else if (state.length === 2) {
        return home
      } else {
        return state.slice(0, -1)
      }
    case SET_HOME_BREADCRUMB:
      let item = Array.isArray(action.item) ? action.item : [action.item]
      // remove falsy array values
      item = item.filter(i => !!i)
      item = item.length > 0 ? item : home
      return item.concat(state.slice(1))
    default:
      return state
  }
}
export default breadcrumbs
